import { render } from "./LeaveAssignConfirmModal.vue?vue&type=template&id=19c585fa&scoped=true"
import script from "./LeaveAssignConfirmModal.vue?vue&type=script&lang=js"
export * from "./LeaveAssignConfirmModal.vue?vue&type=script&lang=js"

import "./LeaveAssignConfirmModal.vue?vue&type=style&index=0&id=19c585fa&scoped=true&lang=css"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c585fa"]])

export default __exports__